import { useLocation } from 'react-router-dom';
import {
  DirectBookingEngineTab,
  DirectBookingEngineTabType,
} from './DirectBookingEngineTabs.constants';

const useDirectBookingEngineActiveTab = (): DirectBookingEngineTabType => {
  const { pathname } = useLocation();

  return (
    Object.values(DirectBookingEngineTab).find((tab) =>
      pathname.endsWith(`/${tab}`),
    ) ?? DirectBookingEngineTab.websiteSettings
  );
};

export default useDirectBookingEngineActiveTab;
